/**
 * Provides an easy way of making a websocket connection.
 */
class WSConnection {
	constructor() {
		this.events = {
			message: {}
		};
	}

	_connect(url) {
		return new Promise((resolve, reject) => {
			const ws = new WebSocket(url);
			ws.onopen = () => {
				delete ws.onopen;
				delete ws.onerror;
				resolve(ws);
			};
			// add error handler to reject if the websocket fails
			// to connect before it opens
			ws.onerror = (e) => {
				// eslint-disable-next-line no-console
				console.error(e);
				reject(new Error('Websocket Connection Failed'));
			};
		});
	}

	_onmessage(msg) {
		try {
			const data = JSON.parse(msg.data);
			const ev = this.events.message[data.id];
			ev && ev(data.data, msg);
		} catch (e) {
			// ignore unsupported messages
		}
	}

	async connect(url) {
		this.ws = await this._connect(url);
		// as soon as the websocket opens use the defined error handler
		this.ws.onerror = this.events.error;
		this.ws.onclose = this.events.close;
		this.ws.onmessage = this._onmessage.bind(this);
	}

	onClose(listener) {
		this.events.close = listener;
		this.ws && (this.ws.onclose = listener);
	}

	onError(listener) {
		this.events.error = listener;
		this.ws && (this.ws.onerror = listener);
	}

	unregisterEventListeners() {
		this.onError(null);
		this.onClose(null);
	}

	sendData(id, data) {
		this.ws.send(JSON.stringify({
			id,
			data
		}));
	}

	disconnect() {
		this.ws.close();
	}

	onData(id, listener) {
		this.events.message[id] = listener;
	}
}

export default WSConnection;
